export default __webpack_public_path__ + "static/media/2.da780506.png";